import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f0f806f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "canvas-tool" }
const _hoisted_2 = { class: "left-handler" }
const _hoisted_3 = { class: "add-element-handler" }
const _hoisted_4 = { class: "handler-item group-btn" }
const _hoisted_5 = { class: "right-handler" }
const _hoisted_6 = { class: "viewport-size-preset" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text" }

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSnapshotStore } from '@/store'
import { getImageDataURL } from '@/utils/image'
import { ShapePoolItem } from '@/configs/shapes'
import { LinePoolItem } from '@/configs/lines'
import useScaleCanvas from '@/hooks/useScaleCanvas'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useCreateElement from '@/hooks/useCreateElement'

import ShapePool from './ShapePool.vue'
import LinePool from './LinePool.vue'
import ChartPool from './ChartPool.vue'
import TableGenerator from './TableGenerator.vue'
import MediaInput from './MediaInput.vue'
import VirtualAvatar from './VirtualAvatar.vue'
import LaTeXEditor from '@/components/LaTeXEditor/index.vue'
import FileInput from '@/components/FileInput.vue'
import {
  Tooltip,
  Popover,
  Modal,
} from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const mainStore = useMainStore()
const { creatingElement } = storeToRefs(mainStore)
const { canUndo, canRedo } = storeToRefs(useSnapshotStore())

const { redo, undo } = useHistorySnapshot()

const {
  scaleCanvas,
  setCanvasScalePercentage,
  resetCanvas,
  canvasScalePercentage,
} = useScaleCanvas()

const canvasScalePresetList = [200, 150, 100, 80, 50]
const canvasScaleVisible = ref(false)

const applyCanvasPresetScale = (value: number) => {
  setCanvasScalePercentage(value)
  canvasScaleVisible.value = false
}

const {
  createImageElement,
  createChartElement,
  createTableElement,
  createLatexElement,
  createVideoElement,
  createAudioElement,
} = useCreateElement()

const insertImageElement = (files: FileList) => {
  const imageFile = files[0]
  if (!imageFile) return
  getImageDataURL(imageFile).then(dataURL => createImageElement(dataURL))
}

const shapePoolVisible = ref(false)
const linePoolVisible = ref(false)
const chartPoolVisible = ref(false)
const tableGeneratorVisible = ref(false)
const mediaInputVisible = ref(false)
const latexEditorVisible = ref(false)
const textTypeSelectVisible = ref(false)
const virtualAvatarVisible = ref(false)

// 绘制文字范围
const drawText = (vertical = false) => {
  mainStore.setCreatingElement({
    type: 'text',
    vertical,
  })
}

// 绘制形状范围
const drawShape = (shape: ShapePoolItem) => {
  mainStore.setCreatingElement({
    type: 'shape',
    data: shape,
  })
  shapePoolVisible.value = false
}

// 绘制线条路径
const drawLine = (line: LinePoolItem) => {
  mainStore.setCreatingElement({
    type: 'line',
    data: line,
  })
  linePoolVisible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_IconBack = _resolveComponent("IconBack")!
  const _component_IconNext = _resolveComponent("IconNext")!
  const _component_IconFontSize = _resolveComponent("IconFontSize")!
  const _component_IconTextRotationNone = _resolveComponent("IconTextRotationNone")!
  const _component_IconTextRotationDown = _resolveComponent("IconTextRotationDown")!
  const _component_IconDown = _resolveComponent("IconDown")!
  const _component_IconPicture = _resolveComponent("IconPicture")!
  const _component_IconGraphicDesign = _resolveComponent("IconGraphicDesign")!
  const _component_IconConnection = _resolveComponent("IconConnection")!
  const _component_IconChartProportion = _resolveComponent("IconChartProportion")!
  const _component_IconInsertTable = _resolveComponent("IconInsertTable")!
  const _component_IconFormula = _resolveComponent("IconFormula")!
  const _component_IconVideoTwo = _resolveComponent("IconVideoTwo")!
  const _component_IconMinus = _resolveComponent("IconMinus")!
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _component_IconFullScreen = _resolveComponent("IconFullScreen")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Tooltip), {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "撤销"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconBack, {
            class: _normalizeClass(["handler-item", { 'disable': !_unref(canUndo) }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(undo)()))
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createVNode(_unref(Tooltip), {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "重做"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconNext, {
            class: _normalizeClass(["handler-item", { 'disable': !_unref(canRedo) }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(redo)()))
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Tooltip), {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "插入文字"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_IconFontSize, {
              class: _normalizeClass(["icon", { 'active': _unref(creatingElement)?.type === 'text' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (drawText()))
            }, null, 8, ["class"]),
            _createVNode(_unref(Popover), {
              trigger: "click",
              visible: textTypeSelectVisible.value,
              "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((textTypeSelectVisible).value = $event))
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", {
                  class: "text-type-item",
                  onClick: _cache[3] || (_cache[3] = () => { drawText(); textTypeSelectVisible.value = false })
                }, [
                  _createVNode(_component_IconTextRotationNone),
                  _createTextVNode(" 横向文本框")
                ]),
                _createElementVNode("div", {
                  class: "text-type-item",
                  onClick: _cache[4] || (_cache[4] = () => { drawText(true); textTypeSelectVisible.value = false })
                }, [
                  _createVNode(_component_IconTextRotationDown),
                  _createTextVNode(" 竖向文本框")
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_IconDown, { class: "arrow" })
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createVNode(FileInput, {
        onChange: _cache[6] || (_cache[6] = files => insertImageElement(files))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入图片"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconPicture, { class: "handler-item" })
            ]),
            _: 1
          }, 8, ["mouseEnterDelay"])
        ]),
        _: 1
      }),
      _createVNode(_unref(Popover), {
        trigger: "click",
        visible: shapePoolVisible.value,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((shapePoolVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(ShapePool, {
            onSelect: _cache[7] || (_cache[7] = shape => drawShape(shape))
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入形状"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconGraphicDesign, {
                class: _normalizeClass(["handler-item", { 'active': _unref(creatingElement)?.type === 'shape' }])
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 8, ["mouseEnterDelay"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(Popover), {
        trigger: "click",
        visible: linePoolVisible.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((linePoolVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(LinePool, {
            onSelect: _cache[9] || (_cache[9] = line => drawLine(line))
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入线条"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconConnection, {
                class: _normalizeClass(["handler-item", { 'active': _unref(creatingElement)?.type === 'line' }])
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 8, ["mouseEnterDelay"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(Popover), {
        trigger: "click",
        visible: chartPoolVisible.value,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((chartPoolVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(ChartPool, {
            onSelect: _cache[11] || (_cache[11] = chart => { _unref(createChartElement)(chart); chartPoolVisible.value = false })
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入图表"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconChartProportion, { class: "handler-item" })
            ]),
            _: 1
          }, 8, ["mouseEnterDelay"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(Popover), {
        trigger: "click",
        visible: tableGeneratorVisible.value,
        "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((tableGeneratorVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(TableGenerator, {
            onClose: _cache[13] || (_cache[13] = ($event: any) => (tableGeneratorVisible.value = false)),
            onInsert: _cache[14] || (_cache[14] = ({ row, col }) => { _unref(createTableElement)(row, col); tableGeneratorVisible.value = false })
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入表格"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconInsertTable, { class: "handler-item" })
            ]),
            _: 1
          }, 8, ["mouseEnterDelay"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(Tooltip), {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "插入公式"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconFormula, {
            class: "handler-item",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (latexEditorVisible.value = true))
          })
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createVNode(_unref(Popover), {
        trigger: "click",
        visible: mediaInputVisible.value,
        "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((mediaInputVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(MediaInput, {
            onClose: _cache[17] || (_cache[17] = ($event: any) => (mediaInputVisible.value = false)),
            onInsertVideo: _cache[18] || (_cache[18] = src => { _unref(createVideoElement)(src); mediaInputVisible.value = false }),
            onInsertAudio: _cache[19] || (_cache[19] = src => { _unref(createAudioElement)(src); mediaInputVisible.value = false })
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入音视频"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconVideoTwo, { class: "handler-item" })
            ]),
            _: 1
          }, 8, ["mouseEnterDelay"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(Popover), {
        trigger: "click",
        visible: virtualAvatarVisible.value,
        "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((virtualAvatarVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(VirtualAvatar, {
            onClose: _cache[21] || (_cache[21] = ($event: any) => (virtualAvatarVisible.value = false)),
            onInsertAvatar: _cache[22] || (_cache[22] = src => { _unref(createImageElement)(src); virtualAvatarVisible.value = false })
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入虚拟头像"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconVideoTwo, { class: "handler-item" })
            ]),
            _: 1
          }, 8, ["mouseEnterDelay"])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_IconMinus, {
        class: "handler-item viewport-size",
        onClick: _cache[24] || (_cache[24] = ($event: any) => (_unref(scaleCanvas)('-')))
      }),
      _createVNode(_unref(Popover), {
        trigger: "click",
        visible: canvasScaleVisible.value,
        "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((canvasScaleVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(canvasScalePresetList, (item) => {
              return _createElementVNode("div", {
                class: "preset-item",
                key: item,
                onClick: ($event: any) => (applyCanvasPresetScale(item))
              }, _toDisplayString(item) + "%", 9, _hoisted_7)
            }), 64))
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(canvasScalePercentage)), 1)
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_IconPlus, {
        class: "handler-item viewport-size",
        onClick: _cache[26] || (_cache[26] = ($event: any) => (_unref(scaleCanvas)('+')))
      }),
      _createVNode(_unref(Tooltip), {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "适应屏幕"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconFullScreen, {
            class: "handler-item viewport-size-adaptation",
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_unref(resetCanvas)()))
          })
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"])
    ]),
    _createVNode(_unref(Modal), {
      visible: latexEditorVisible.value,
      "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => ((latexEditorVisible).value = $event)),
      footer: null,
      centered: "",
      width: 880,
      destroyOnClose: ""
    }, {
      default: _withCtx(() => [
        _createVNode(LaTeXEditor, {
          onClose: _cache[28] || (_cache[28] = ($event: any) => (latexEditorVisible.value = false)),
          onUpdate: _cache[29] || (_cache[29] = data => { _unref(createLatexElement)(data); latexEditorVisible.value = false })
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})